import apiKomisi from '@/api/vo-general/komisi';

const defaultState = () => ({
	summaryKomisi: {},
	potency: {},
	summaryTransfer: {},

	listDetailUnilevel: [],
	detailUnilevelPagination: '',

	listHistoryKomisi: [],
	historyKomisiPagination: '',

	listHistoryTransfer: [],
	historyTransferPagination: '',

	responSukses: {},
	responseError: {},
	konfirmResponse: {},
});

const state = defaultState();

const getters = {

};

const mutations = {

	setSummaryKomisi(state, data) {
		state.summaryKomisi = data
	},

	setSummaryTransfer(state, data) {
		state.summaryTransfer = data
	},

	setPotencyKomisi(state, data) {
		state.potency = data
	},

	setHistoryKomisi(state, data) {
		state.listHistoryKomisi = data.results;
		state.historyKomisiPagination = data.pagination;
	},

	setHistoryTranfer(state, data) {
		state.listHistoryTransfer = data.results;
		state.historyTransferPagination = data.pagination;
	},

	setListDetailUnilevel(state, data) {
		state.listDetailUnilevel = data.results;
		state.detailUnilevelPagination = data.pagination;
	},

	saveResponseError(state, data) {
		state.responseError = data;
	},
	saveResponse(state, data) {
		state.responSukses = data
		state.responseError = ''
	},
};

const actions = {
	getSummaryKomisi({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getSummaryKomisi(params).then((results) => {
				const data = results.data
					commit('setSummaryKomisi', data.data.results);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getSummaryTransfer({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getSummaryTransfer(params).then((results) => {
				const data = results.data
					commit('setSummaryTransfer', data.data.results);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getPotencyKomisi({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getPotencyKomisi(params).then((results) => {
				const data = results.data
					commit('setPotencyKomisi', data.data.results);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getHistoryKomisi({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getHistoryKomisi(params).then((results) => {
				const data = results.data.data
					commit('setHistoryKomisi', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getDetailUnilevel({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getDetailUnilevel(params).then((results) => {
				const data = results.data.data
					commit('setListDetailUnilevel', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getHistoryTransfer({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiKomisi.getHistoryTransfer(params).then((results) => {
				const data = results.data.data
					commit('setHistoryTranfer', data);
					resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;

			}
		}
	},

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};